export default __webpack_public_path__ + "static/industryAdaptBg-06892ab74fa7b9a0036f9e4c3ffc68c3.png";